import React from 'react';
import { useSelector } from 'react-redux';
import Image from '../Image/Image';
import { CategoryLink } from '../form-elements/Link';
import { markenStandortSelector } from '../../../modules/selectors/standort/markenStandort';

function CategoryCard({ category }) {
    // const hideCategory = ["Alufelgen","Ganzjahresreifen",'Sommerreifen','Stahlfelgen','Winterreifen'];
    const markenStandort = useSelector(markenStandortSelector);
    let path = 'main_klein';
    if(markenStandort.isNonGS){
        path = `isNonGS_klein/${markenStandort.gesellschafterNr}/${markenStandort.standortNr}`;
    }
              
    return (
        <>
        <CategoryLink category={category} modifier="reset" ariaLabel={category.title}>
            <div className="uk-card uk-card-small uk-text-center uk-card-default">
                <Image
                    className="uk-flex uk-flex-center uk-width-1-1"
                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/cat-images/${path}/${category.url}.jpg`}
                    alt={category.title}
                />
                <div className="uk-card-footer uk-card-secondary uk-text-truncate">{category.title.toUpperCase()}</div>
            </div>
        </CategoryLink>
        </>
    );
}

export default CategoryCard;
